<script setup lang="ts">
  type Props = {
    label?: string | undefined
    description?: string | undefined
    required?: boolean | undefined
  }

  defineProps<Props>()

  const checked = defineModel<boolean | undefined>()
</script>

<template>
  <div class="field-container checkbox-field">
    <label class="checkbox-label">
      <input v-model="checked" type="checkbox" />
      <span class="checkbox-text">
        {{ label }}
        <span v-if="required" class="required-field">*</span>
      </span>
    </label>

    <span v-if="description" class="field-description">{{ description }}</span>
  </div>
</template>

<style scoped>
  .checkbox-field {
    display: flex;
    flex-direction: column;
    margin: 0.5rem 0;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .checkbox-label input {
    margin-right: 0.5rem;
  }

  .checkbox-text {
    position: relative;
  }

  .required-field {
    color: red;
    margin-left: 0.25rem;
  }

  .field-description {
    color: gray;
    font-size: 0.8rem;
    margin-top: 0.2rem;
  }
</style>
